/* eslint-disable default-param-last */
import { getAccessToken, getRefreshToken, getTempToken } from "helpers/tokenStorage";
import { types } from "../types/types";

const emptyState = {
  accessToken: "",
  refreshToken: "",
  tempToken: "",
  user: {
    email: "",
    firstName: "",
    mobile_phone: "",
    city: "",
    address: "",
    termsAgreed: false,
    deliveryCity: "",
    deliveryAddress: "",
    deliveryDistrict: "",
    deliveryNotes: "",
    deliveryTime: "AM",
  },
};

const ini = {
  ...emptyState,
  accessToken: getAccessToken(),
  refreshToken: getRefreshToken(),
  tempToken: getTempToken(),
};

export const userReducer = (state = ini, action: any) => {
  switch (action.type) {
    case types.user:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        tempToken: "",
      };
    case types.userDt:
      return {
        ...state,
        user: action.payload.user,
      };
    case types.setTempToken:
      return {
        ...state,
        accessToken: "",
        refreshToken: "",
        tempToken: action.payload.tempToken,
      };
    case types.tempTokenExpired:
      return {
        ...state,
        tempToken: "",
      };
    case types.logout:
      return {
        ...state,
        accessToken: "",
        refreshToken: "",
        user: state.tempToken ? state.user : emptyState.user,
      };
    default:
      return state;
  }
};
